import React, { useEffect } from "react";
import { Fragment } from "react";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import InputField from "../components/Admin/Reusable/InputField";
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { isEmpty, isUndefined } from "lodash";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import { baseUrl, basicFormValidationHandler } from "../utils";
import {
  fetchTestimonialsPagesList,
  fetchCreateNewTestimonials,
  fetchEditTestimonials,
} from "../actions/testimonials";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";

const Testimonials = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dataPagesDetail } = useSelector((state) => state.testimonialsReducer);

  const resetState = useCallback(() => {
    return {
      acName: "",
      acDescription: "",
      acImage: "",
      acImageBlock: "",
      anStatus: 1,
      anLanguage: 1,
      acPosition: "",
    };
  }, []);

  const initialState = {
    acName: "",
    acDescription: "",
    acImage: "",
    acImageBlock: "",
    anStatus: 1,
    anLanguage: 1,
    acPosition: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedBlockFile, setSelectedBlockFile] = useState("");

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / 1048576; // Konvertujemo veličinu u MB
      if (fileSizeInMB <= 2) {
        setSelectedFile(file);
      } else {
        toast.error(
          "Odabrana slika je prevelika. Maksimalna veličina je 2MB.",
          { theme: "colored" }
        );
        setData((prevUser) => ({
          ...prevUser,
          acImage: null,
        }));
        event.target.value = null; // Resetujemo input
      }
    }
  };

  const handleBlockFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / 1048576; // Konvertujemo veličinu u MB
      if (fileSizeInMB <= 2) {
        setSelectedBlockFile(file);
      } else {
        toast.error(
          "Odabrana slika je prevelika. Maksimalna veličina je 2MB.",
          { theme: "colored" }
        );
        setData((prevUser) => ({
          ...prevUser,
          acImageBlock: null,
        }));
        event.target.value = null; // Resetujemo input
      }
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchTestimonialsPagesList(id));
    } else {
      setData(resetState());
    }
  }, [id, dispatch, resetState]);

  useEffect(() => {
    if (dataPagesDetail && Object.keys(dataPagesDetail).length > 0) {
      setData(dataPagesDetail);
    }
  }, [dataPagesDetail]);

  const testimonialsValidationHandler = () => {
    const { acName, acPosition, acDescription } = data;
    let errorsObject = {};
    if (id) {
      errorsObject = basicFormValidationHandler({
        acName,
        acPosition,
        acDescription,
      });
    } else {
      errorsObject = basicFormValidationHandler({
        acName,
        acPosition,
        acDescription,
        selectedFile,
        selectedBlockFile,
      });
    }
    setErrors(errorsObject);
    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (testimonialsValidationHandler()) {
      return;
    }

    const formData = new FormData();

    formData.append("acName", data.acName);
    formData.append("acDescription", data.acDescription);
    formData.append("anStatus", data.anStatus);
    formData.append("anLanguage", data.anLanguage);
    formData.append("acPosition", data.acPosition);
    selectedFile && formData.append("acImage", selectedFile);
    selectedBlockFile && formData.append("acImageBlock", selectedBlockFile);

    if (id) {
      formData.append("anId", id);
      dispatch(fetchEditTestimonials(formData, navigate));
    } else {
      dispatch(fetchCreateNewTestimonials(formData, navigate));
    }
  };

  return (
    <Fragment>
      <Breadcrumb title="Rekli su o nama" type="testimonials-forma" />
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h1 className="card-title mb-0 flex-grow-1">
                {/* Kreiranje novog pitanja */}
                {id ? `Izmena stavke` : "Kreiranje nove stavke"}
              </h1>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-6">
                    <FormControl fullWidth className="mb-4">
                      <InputLabel id="demo-simple-select-label">
                        Jezik
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={data.anLanguage}
                        label="Jezik"
                        name="anLanguage"
                        onChange={handleInputChange}
                        size="small"
                      >
                        <MenuItem value="1">Srpski</MenuItem>
                        <MenuItem value="2">Engleski</MenuItem>
                      </Select>
                    </FormControl>
                    <InputField
                      required
                      label="Ime i prezime"
                      name="acName"
                      error={errors}
                      errorsHandler={setErrors}
                      value={data.acName}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      className="mb-4"
                    />
                    <InputField
                      required
                      label="Pozicija"
                      name="acPosition"
                      error={errors}
                      errorsHandler={setErrors}
                      value={data.acPosition}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      className="mb-4"
                    />
                    <InputField
                      required
                      multiline
                      rows={8}
                      label="Opis"
                      name="acDescription"
                      error={errors}
                      errorsHandler={setErrors}
                      value={data.acDescription}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      className="mb-4"
                    />
                    <FormControl fullWidth className="mb-4">
                      <InputLabel id="demo-simple-select-label">
                        Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={data.anStatus}
                        label="Status"
                        name="anStatus"
                        onChange={handleInputChange}
                        size="small"
                      >
                        <MenuItem value="1">Aktivan</MenuItem>
                        <MenuItem value="0">Neaktivan</MenuItem>
                      </Select>
                    </FormControl>
                    {id && (
                      <div className="inseted-document-link">
                        Odabrana slika:&nbsp;
                        <div>
                          <img
                            src={
                              baseUrl + "images/" + dataPagesDetail.acImageBlock
                            }
                            className="img-fluid image-preview-block-table-detail"
                            alt="UP IT"
                          />
                        </div>
                      </div>
                    )}

                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginBottom: "10px" }}
                    >
                      Pozadinska slika <br />
                      <small>
                        <i>
                          (maksimalna veličina slike do <b>2MB</b>)
                        </i>
                      </small>
                      <br />
                      <small>
                        <i>
                          (dozvoljeni formati <b>.jpg, .jpeg, .png, .svg</b>)
                        </i>
                      </small>
                    </InputLabel>
                    <Input
                      required
                      type="file"
                      error={!isUndefined(errors["selectedBlockFile"])}
                      className="form-control"
                      onChange={(e) => {
                        if (e.target.files.length === 0) {
                          setSelectedBlockFile(null);
                        } else {
                          handleBlockFileSelect(e);
                        }
                      }}
                      id="file-input2"
                      name="acFileName"
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="file-input2"
                      style={{ position: "relative" }}
                    >
                      <Button
                        variant="contained"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                      >
                        Priložite sliku
                      </Button>
                      {!isUndefined(errors["selectedBlockFile"]) && (
                        <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained Mui-required css-k4qjio-MuiFormHelperText-root">
                          prilog je obavezan!
                        </p>
                      )}
                    </label>
                    {selectedBlockFile && (
                      <div>
                        <br />
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                Odabrana slika: <b>{selectedBlockFile.name}</b>{" "}
                                (Veličina:{" "}
                                {(selectedBlockFile.size / 1048576).toFixed(2)}{" "}
                                MB)
                                {selectedBlockFile && (
                                  <div className="preview-image-holder-admin">
                                    <img
                                      src={URL.createObjectURL(
                                        selectedBlockFile
                                      )}
                                      alt={selectedBlockFile.name}
                                    />
                                  </div>
                                )}
                              </td>
                              <td>
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => {
                                    setSelectedBlockFile(null);
                                    document.getElementById(
                                      "file-input2"
                                    ).value = ""; // Resetovanje input polja za datoteku
                                  }}
                                >
                                  Obriši
                                </Button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p></p>
                      </div>
                    )}
                  </div>

                  <div className="col-6">
                    {id && (
                      <div className="inseted-document-link">
                        Odabrana slika:&nbsp;
                        <div>
                          <img
                            src={baseUrl + "images/" + dataPagesDetail.acImage}
                            className="img-fluid image-preview-block-table-detail"
                            alt="UP IT"
                          />
                        </div>
                      </div>
                    )}

                    <InputLabel
                      id="demo-simple-select-label"
                      style={{ marginBottom: "10px" }}
                    >
                      Slika <br />
                      <small>
                        <i>
                          (maksimalna veličina slike do <b>2MB</b>)
                        </i>
                      </small>
                      <br />
                      <small>
                        <i>
                          (dozvoljeni formati <b>.jpg, .jpeg, .png, .svg</b>)
                        </i>
                      </small>
                    </InputLabel>
                    <Input
                      required
                      type="file"
                      error={!isUndefined(errors["selectedFile"])}
                      className="form-control"
                      onChange={(e) => {
                        if (e.target.files.length === 0) {
                          setSelectedFile(null);
                        } else {
                          handleFileSelect(e);
                        }
                      }}
                      id="file-input"
                      name="acFileName"
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="file-input"
                      style={{ position: "relative" }}
                    >
                      <Button
                        variant="contained"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                      >
                        Priložite sliku
                      </Button>
                      {!isUndefined(errors["selectedFile"]) && (
                        <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained Mui-required css-k4qjio-MuiFormHelperText-root">
                          prilog je obavezan!
                        </p>
                      )}
                    </label>
                    {selectedFile && (
                      <div>
                        <br />
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                Odabrana slika: <b>{selectedFile.name}</b>{" "}
                                (Veličina:{" "}
                                {(selectedFile.size / 1048576).toFixed(2)} MB)
                                {selectedFile && (
                                  <div className="preview-image-holder-admin">
                                    <img
                                      src={URL.createObjectURL(selectedFile)}
                                      alt={selectedFile.name}
                                    />
                                  </div>
                                )}
                              </td>
                              <td>
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => {
                                    setSelectedFile(null);
                                    document.getElementById(
                                      "file-input"
                                    ).value = ""; // Resetovanje input polja za datoteku
                                  }}
                                >
                                  Obriši
                                </Button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p></p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="float-end mt-3">
                  {id ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      startIcon={<CheckIcon />}
                    >
                      Potvrda izmene
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      startIcon={<AddIcon />}
                    >
                      Kreiraj
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Testimonials;
